import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/post.ts

var post_exports = {};

__export(post_exports, {
  block: function block() {
    return _block;
  },
  createPostComment: function createPostComment() {
    return _createPostComment;
  },
  deletePost: function deletePost() {
    return _deletePost;
  },
  getChannelPosts: function getChannelPosts() {
    return _getChannelPosts;
  },
  getClientPosts: function getClientPosts() {
    return _getClientPosts;
  },
  getFollowingPosts: function getFollowingPosts() {
    return _getFollowingPosts;
  },
  getGroupClassPosts: function getGroupClassPosts() {
    return _getGroupClassPosts;
  },
  getGroupPosts: function getGroupPosts() {
    return _getGroupPosts;
  },
  getLatestPosts: function getLatestPosts() {
    return _getLatestPosts;
  },
  getMediaPosts: function getMediaPosts() {
    return _getMediaPosts;
  },
  getMyKeptPosts: function getMyKeptPosts() {
    return _getMyKeptPosts;
  },
  getMyPosts: function getMyPosts() {
    return _getMyPosts;
  },
  getPost: function getPost() {
    return _getPost;
  },
  getSocialClient: function getSocialClient() {
    return _getSocialClient;
  },
  getSocialPosts: function getSocialPosts() {
    return _getSocialPosts;
  },
  getSocialSearch: function getSocialSearch() {
    return _getSocialSearch;
  },
  getSocialUser: function getSocialUser() {
    return _getSocialUser;
  },
  getTagPosts: function getTagPosts() {
    return _getTagPosts;
  },
  getUserPosts: function getUserPosts() {
    return _getUserPosts;
  },
  report: function report() {
    return _report;
  },
  toggleFollowClient: function toggleFollowClient() {
    return _toggleFollowClient;
  },
  toggleFollowUser: function toggleFollowUser() {
    return _toggleFollowUser;
  },
  togglePostKeep: function togglePostKeep() {
    return _togglePostKeep;
  },
  togglePostLike: function togglePostLike() {
    return _togglePostLike;
  },
  unBlock: function unBlock() {
    return _unBlock;
  }
});

var getQueryObject = function getQueryObject() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var order_key_cursor = payload.orderKey,
      tag_id = payload.tagId,
      group_class_id = payload.groupClassId,
      target_type = payload.targetType,
      target_id = payload.targetId,
      type = payload.type;
  var count = type === "first" ? 6 : 20;

  var params = _objectSpread(_objectSpread({}, payload), {}, {
    count: count,
    order_key_cursor: order_key_cursor,
    tag_id: tag_id,
    group_class_id: group_class_id,
    target_type: target_type,
    target_id: target_id
  });

  return params;
};

var _getSocialClient = function _getSocialClient(_ref) {
  var id = _ref.id;
  return fetcher_default.get("/v4/clients/".concat(id));
};

var _getSocialUser = function _getSocialUser(_ref2) {
  var id = _ref2.id;
  return fetcher_default.get("/v4/users/".concat(id));
};

var _getMediaPosts = function _getMediaPosts(payload) {
  return fetcher_default.get("/v4/media_posts", payload);
};

var _getSocialPosts = function _getSocialPosts(payload) {
  return fetcher_default.get("/v4.1/social_posts", getQueryObject(payload));
};

var _getLatestPosts = function _getLatestPosts(payload) {
  return fetcher_default.get("/v4.1/latest_posts", getQueryObject(payload));
};

var _getChannelPosts = function _getChannelPosts(payload) {
  console.log(payload);
  return fetcher_default.get("/v4/get_posts", getQueryObject(payload));
};

var _getMyPosts = function _getMyPosts(payload) {
  return fetcher_default.get("/v4.1/my_posts", getQueryObject(payload));
};

var _getTagPosts = function _getTagPosts(payload) {
  return fetcher_default.get("/v4.1/tagging_posts", getQueryObject(payload));
};

var _getGroupClassPosts = function _getGroupClassPosts(payload) {
  return fetcher_default.get("/v4.1/group_class_posts", getQueryObject(payload));
};

var _getGroupPosts = function _getGroupPosts(payload) {
  return fetcher_default.get("/v4.1/social_group_posts", getQueryObject(payload));
};

var _getFollowingPosts = function _getFollowingPosts(payload) {
  return fetcher_default.get("/v4.1/following_posts", getQueryObject(payload));
};

var _getClientPosts = function _getClientPosts(payload) {
  return fetcher_default.get("/v4.1/clients/".concat(payload.id, "/posts"), getQueryObject(payload));
};

var _getUserPosts = function _getUserPosts(payload) {
  return fetcher_default.get("/v4.1/users/".concat(payload.id, "/posts"), getQueryObject(payload));
};

var _getPost = function _getPost(_ref3) {
  var id = _ref3.id;
  return fetcher_default.get("/v4/posts/".concat(id));
};

var _deletePost = function _deletePost(_ref4) {
  var id = _ref4.id;
  return fetcher_default["delete"]("/v4/posts/".concat(id), {});
};

var _createPostComment = function _createPostComment(_ref5) {
  var id = _ref5.id,
      content = _ref5.content,
      _tag_members = _ref5._tag_members,
      displayText = _ref5.displayText;
  return fetcher_default.post("/v4/posts/".concat(id, "/create_comment"), {
    content: content,
    _tag_members: _tag_members,
    displayText: displayText
  });
};

var _togglePostLike = function _togglePostLike(_ref6) {
  var id = _ref6.id,
      liked = _ref6.liked;
  var action = liked ? "like" : "unlike";
  return fetcher_default.post("/v4/posts/".concat(id, "/").concat(action));
};

var _toggleFollowClient = function _toggleFollowClient(_ref7) {
  var follow = _ref7.follow,
      id = _ref7.id;
  var action = follow ? "follow" : "unfollow";
  return fetcher_default.post("/v4/clients/".concat(id, "/").concat(action));
};

var _toggleFollowUser = function _toggleFollowUser(_ref8) {
  var follow = _ref8.follow,
      id = _ref8.id;
  var action = follow ? "follow" : "unfollow";
  return fetcher_default.post("/v4/users/".concat(id, "/").concat(action));
};

var _getSocialSearch = function _getSocialSearch(param) {
  return fetcher_default.get("/v4/social/search/", param);
};

var _report = function _report(param) {
  return fetcher_default.post("/v4/social/report", param);
};

var _block = function _block(param) {
  return fetcher_default.post("/v4/social/block", param);
};

var _unBlock = function _unBlock(param) {
  return fetcher_default.post("/v4/social/unblock", param);
};

var _togglePostKeep = function _togglePostKeep(_ref9) {
  var id = _ref9.id,
      kept = _ref9.kept;
  var action = kept ? "keep" : "unkeep";
  return fetcher_default.post("/v4/posts/".concat(id, "/").concat(action));
};

var _getMyKeptPosts = function _getMyKeptPosts(payload) {
  return fetcher_default.get("/v4.1/kept_posts", getQueryObject(payload));
};

export { _getSocialClient as getSocialClient, _getSocialUser as getSocialUser, _getMediaPosts as getMediaPosts, _getSocialPosts as getSocialPosts, _getLatestPosts as getLatestPosts, _getChannelPosts as getChannelPosts, _getMyPosts as getMyPosts, _getTagPosts as getTagPosts, _getGroupClassPosts as getGroupClassPosts, _getGroupPosts as getGroupPosts, _getFollowingPosts as getFollowingPosts, _getClientPosts as getClientPosts, _getUserPosts as getUserPosts, _getPost as getPost, _deletePost as deletePost, _createPostComment as createPostComment, _togglePostLike as togglePostLike, _toggleFollowClient as toggleFollowClient, _toggleFollowUser as toggleFollowUser, _getSocialSearch as getSocialSearch, _report as report, _block as block, _unBlock as unBlock, _togglePostKeep as togglePostKeep, _getMyKeptPosts as getMyKeptPosts, post_exports };